import axios from '@/plugins/axios'
import BillNegotiation from './BillNegotiation'
import BillInstallmet from './BillInstallment'
import Model from '@/shared/models/Bill'
import i18n from '@/plugins/i18n'
import Period from './Period'
import Reseller from './Reseller'
import { isNull } from 'lodash'

export default class Bill extends Model {
    resourceName() {
        return 'bills'
    }

    relationships() {
        return {
            reseller: new Reseller(),
            periods: new Period(),
            billNegotiation: new BillNegotiation(),
            billInstallments: new BillInstallmet(),
        }
    }

    async recalculate() {
        return await axios.put(`${this.getSelfUrl()}/recalculate`)
    }

    async transmit() {
        return await axios.put(`${this.getSelfUrl()}/transmit`)
    }

    async sync() {
        return this.makePersistRequest({
            url: `${this.getSelfUrl()}/sync`,
            method: 'PUT',
        })
    }

    async cancelCharging() {
        return await axios.put(`${this.getSelfUrl()}/cancelCharging`)
    }

    async archive() {
        return this.makePersistRequest({
            url: `${this.getSelfUrl()}/archive`,
            method: 'PUT',
        })
    }

    async unarchive() {
        return this.makePersistRequest({
            url: `${this.getSelfUrl()}/unarchive`,
            method: 'PUT',
        })
    }

    async negotiate(installments, firstOn) {
        return this.makePersistRequest({
            url: `${this.getSelfUrl()}/negotiate`,
            method: 'PUT',
            data: {
                installments: installments,
                first_on: firstOn,
            },
        })
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.bill.attributes.reseller_id'),
                value: 'reseller.trade_name',
                sortable: false,
            },
            {
                text: i18n.t('resources.bill.attributes.reference'),
                value: 'reference',
                sortable: false,
            },
            {
                text: i18n.t('resources.bill.attributes.due_at'),
                value: 'formattedDueAt',
                sortable: false,
            },
            {
                text: i18n.t('resources.bill.attributes.totalValue'),
                value: 'formattedTotalValue',
                sortable: false,
            },
            {
                text: i18n.t('resources.bill.attributes.paid_at'),
                value: 'formattedPaidAt',
                sortable: false,
            },
            {
                text: i18n.t('resources.bill.attributes.has_negotiation'),
                value: 'has_negotiation',
                sortable: false,
                align: 'center',
            },
            {
                text: 'Ações',
                value: 'action',
                sortable: false,
                width: 150,
                align: 'end',
            },
        ]
    }

    get actions() {
        return [
            {
                type: 'menu',
                actions: [
                    {
                        type: 'recalculate',
                        label: i18n.t('actions.bill.recalculate.label'),
                        disabled: !isNull(this.payment_gateway_id),
                    },
                    {
                        type: 'transmit',
                        label: i18n.t('actions.bill.transmit.label'),
                        disabled: !isNull(this.payment_gateway_id),
                    },
                    {
                        type: 'accessPaymentPage',
                        label: i18n.t('actions.bill.paymentPage.label'),
                        disabled: !this.url,
                    },
                    {
                        type: 'accessNFPage',
                        label: i18n.t('actions.bill.nfPage.label'),
                        disabled: !this.invoice_url,
                    },
                    {
                        type: 'sync',
                        label: i18n.t('actions.bill.sync.label'),
                        disabled: isNull(this.payment_gateway_id),
                    },
                    {
                        type: 'cancelCharging',
                        label: i18n.t('actions.bill.cancelCharging.label'),
                        disabled: isNull(this.payment_gateway_id),
                    },
                    {
                        type: 'archive',
                        label: i18n.t('actions.bill.archive.label'),
                        disabled: this.paid_at.isValid(),
                        hide: this.archived,
                    },
                    {
                        type: 'unarchive',
                        label: i18n.t('actions.bill.unarchive.label'),
                        hide: !this.archived,
                    },
                    {
                        type: 'negotiate',
                        label: i18n.t('actions.bill.negotiate.label'),
                    },
                ],
            },
            {
                type: 'show',
                to: {
                    name: 'bill.show',
                    params: { id: this.id },
                },
            },
            {
                type: 'edit',
                to: {
                    name: 'bill.edit',
                    params: { id: this.id },
                },
            },
        ]
    }
}
